import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';
import { hasBalance } from '../../../../utils/helperFunctions';

export const fetchScheduleReport = createAsyncThunk(
	'user/fetchScheduleReport',
	async ({user}) => {
		try {
			const response = await fetchFun(`/api/v1/schedules?userId=${user?._id}`, 'GET');
			if(response?.success) {
				const filteredData = response?.data?.body?.filter(item => item?.subEntries.some(entry => hasBalance(entry)));
				
				const updatedResponse = {
				...response?.data,
				body: filteredData
				};
				return updatedResponse
			}
		} catch(error) {
			console.log("Error - /api/v1/schedules", error)
		}
	}
)